import React from 'react'
import type { IOccurrencesAssociatedObject, ResponseProps } from '../interfaces'
import { createState, useState, type State } from '@hookstate/core'
import {
  getOccurrencesAssociatedObjectByType,
  getOccurrencesAssociatedObjectByCircunstance,
  getOccurrencesAssociatedObjectByDestination,
  getOccurrencesAssociatedObjectByOccurrenceType,
} from '../components/QualifiersCharts/Object/services'

interface IOccurrencesAssociatedObjectProps {
  readonly occurrencesAssociatedObject: IOccurrencesAssociatedObject
  readonly loadingCharts: boolean
}

const occurrencesAssociatedObjectProps: Readonly<ResponseProps> = {
  item: null,
  value: null,
  total: null,
}

const occurrencesAssociatedObjectDefault: Readonly<IOccurrencesAssociatedObject> =
  {
    occurrencesAssociatedObjectByType: occurrencesAssociatedObjectProps,
    occurrencesAssociatedObjectByCircunstance: occurrencesAssociatedObjectProps,
    occurrencesAssociatedObjectByDestination: occurrencesAssociatedObjectProps,
    occurrencesAssociatedObjectByOccurrenceType:
      occurrencesAssociatedObjectProps,
  }

const store = createState<Readonly<IOccurrencesAssociatedObjectProps>>({
  occurrencesAssociatedObject: occurrencesAssociatedObjectDefault,
  loadingCharts: true,
})

interface getAllsAssociatedObjectDataProps {
  readonly startDate: string | null
  readonly finishDate: string | null
  readonly objectTypeId: number | null
  readonly destinationId: number | null
  readonly circunstanceId: number | null
}

export default function useManagementQualifiersObjectState() {
  const occurrencesAssociatedObject: State<
    Readonly<IOccurrencesAssociatedObject>
  > = useState(store.occurrencesAssociatedObject)
  const loadingCharts = useState(store.loadingCharts)

  async function getAssociatedObjectStats({
    startDate,
    finishDate,
    objectTypeId,
    destinationId,
    circunstanceId,
  }: getAllsAssociatedObjectDataProps) {
    const params = {
      startDate,
      finishDate,
      objectTypeId,
      destinationId,
      circumstanceId: circunstanceId,
    }

    loadingCharts.set(true)

    Promise.all([
      getOccurrencesAssociatedObjectByType(params).then((response) => {
        occurrencesAssociatedObject.occurrencesAssociatedObjectByType.set(response)
      }),
      getOccurrencesAssociatedObjectByCircunstance(params).then((response) => {
        occurrencesAssociatedObject.occurrencesAssociatedObjectByCircunstance.set(
          response
        )
      }),
      getOccurrencesAssociatedObjectByDestination(params).then((response) => {
        occurrencesAssociatedObject.occurrencesAssociatedObjectByDestination.set(
          response
        )
      }),
      getOccurrencesAssociatedObjectByOccurrenceType(params).then(
        (response) => {
          occurrencesAssociatedObject.occurrencesAssociatedObjectByOccurrenceType.set(
            response
          )
        }
      ),
    ]).finally(() => {
      loadingCharts.set(false)
    })
  }

  return {
    occurrencesAssociatedObject: () => occurrencesAssociatedObject,
    fetchAllAssociatedObjectData: async ({
      destinationId,
      finishDate,
      objectTypeId,
      circunstanceId,
      startDate,
    }) =>
      getAssociatedObjectStats({
        destinationId,
        finishDate,
        objectTypeId,
        circunstanceId,
        startDate,
      }),
    loadingCharts: loadingCharts,
  }
}
